module.exports = __webpack_public_path__ + "img/icon-warning-icing-orange.164e1664.svg";